import { Context, createContext, JSX, ReactNode, useContext } from 'react'
import { createPortal } from 'react-dom'
import styles from './DialogActions.module.scss'

interface DialogActionsProps {
    children: ReactNode
    className?: string
    block?: boolean
}

interface DialogActionsTargetValue {
    target: HTMLDivElement | null
    renderWrapper: boolean
    footerClassName?: string
}

const DEFAULT_TARGET: DialogActionsTargetValue = { target: null, renderWrapper: false }

export const DialogActionsTarget: Context<DialogActionsTargetValue> =
    createContext<DialogActionsTargetValue>(DEFAULT_TARGET)

export default function DialogActions({ children, className, block = false }: DialogActionsProps) {
    const { target, renderWrapper, footerClassName } = useContext(DialogActionsTarget)
    const actions: JSX.Element = (
        <div className={`${styles.Actions} ${className ?? ''} ${block && styles.Column} ${footerClassName ?? ''}`}>
            {children}
        </div>
    )

    return target ? createPortal(renderWrapper ? actions : children, target) : actions
}
